import React, { Component } from 'react';


export default class LoginViewTour extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            rightArrow: '0rem',
            leftArrow: '0rem'
        }

        this.getTopOffset = this.getTopOffset.bind(this);
        this.getLeftOffset = this.getLeftOffset.bind(this);
        this.getOpacity = this.getOpacity.bind(this);

        this.clickLeft = this.clickLeft.bind(this);
        this.clickRight = this.clickRight.bind(this);
    }

    componentDidMount() { }

    componentWillReceiveProps() { }

    getTopOffset(index) {
        if (index - this.props.pageIndex === 0) {
            return '0rem';
        } else if (index - this.props.pageIndex < 0) {
            return '-1rem';
        } else {
            return '1rem';
        }
    }

    getLeftOffset(index) {

        if (index - this.props.pageIndex === 0) {
            return '0rem';
        } else if (index - this.props.pageIndex < 0) {
            return '-5rem';
        } else {
            return '5rem';
        }
    }

    getOpacity(index) {
        if (index - this.props.pageIndex === 0) {
            return '1';
        } else {
            return '0';
        }
    }

    clickLeft() {
        var self = this;

        this.props.pagePrevious();
        this.setState({ leftArrow: '-1rem' });
        setTimeout(() => {
            self.setState({ leftArrow: '0rem' });
        }, 125);
    }

    clickRight() {
        var self = this;

        this.props.pageNext();
        this.setState({ rightArrow: '-1rem' });
        setTimeout(() => {
            self.setState({ rightArrow: '0rem' });
        }, 125);
    }


    render() {

        let outerClass;
        (this.props.pageIndex === 0) ? outerClass = "tour-outer" : outerClass = "tour-outer tour-outer--active";

        let backPosition = ['0% 0%', '0% 0%', '33% 0%', '67% 0%', '100% 0%'];

        return (
            <div style={{ backgroundPosition: backPosition[this.props.pageIndex] }} className={outerClass}>
                <div className="tour-inner">
                    <div className="tour-counter-container">
                        <div className="tour-counter" style={{ top: this.getTopOffset(1), opacity: this.getOpacity(1) }}>1</div>
                        <div className="tour-counter" style={{ top: this.getTopOffset(2), opacity: this.getOpacity(2) }}>2</div>
                        <div className="tour-counter" style={{ top: this.getTopOffset(3), opacity: this.getOpacity(3) }}>3</div>
                        <div className="tour-counter" style={{ top: this.getTopOffset(4), opacity: this.getOpacity(4) }}>4</div>
                        <div className="tour-counter-center">of</div>
                        <div className="tour-counter-final">{backPosition.length - 1}</div>
                    </div>
                    <div className="tour-image-container">
                        <div className="tour-image material-icons" style={{ left: this.getLeftOffset(1), opacity: this.getOpacity(1) }}>timer</div>
                        <div className="tour-image material-icons" style={{ left: this.getLeftOffset(2), opacity: this.getOpacity(2) }}>smartphone</div>
                        <div className="tour-image material-icons" style={{ left: this.getLeftOffset(3), opacity: this.getOpacity(3) }}>favorite_border</div>
                        <div className="tour-image material-icons" style={{ left: this.getLeftOffset(4), opacity: this.getOpacity(4) }}>attach_money</div>
                    </div>
                    <div className="tour-message-container">
                        <div className="tour-message" style={{ left: this.getLeftOffset(1), opacity: this.getOpacity(1) }}>Make quicker decisions with real-time data so you can run your business, not reports</div>
                        <div className="tour-message" style={{ left: this.getLeftOffset(2), opacity: this.getOpacity(2) }}>Access your data anytime, anyplace so you can maintain a pulse on your business</div>
                        <div className="tour-message" style={{ left: this.getLeftOffset(3), opacity: this.getOpacity(3) }}>Engage employees at a new level as you connect with them about their metrics and milestones</div>
                        <div className="tour-message" style={{ left: this.getLeftOffset(4), opacity: this.getOpacity(4) }}>Drive key metrics to focus employees and grow profits</div>
                    </div>
                    <div className="tour-button-container">
                        <div className="tour-button-left material-icons" style={{ left: this.state.leftArrow }} onClick={this.clickLeft}>arrow_back</div>
                        <div className="tour-button-right material-icons" style={{ right: this.state.rightArrow }} onClick={this.clickRight}>arrow_forward</div>
                    </div>
                </div>
            </div>
        );
    }
}
